export const ROUTE_HOME = '/';
export const ROUTE_PASSWORD_REQUEST = '/wachtwoord-vergeten';
export const ROUTE_PASSWORD_RESET = '/user/reset/';
export const ROUTE_ACCOUNT_LOGIN = '/login';
export const ROUTE_ACCOUNT_EDIT = '/account/personal';
export const ROUTE_ACCOUNT_REGISTER = '/register';
export const ROUTE_ACCOUNT_REGISTER_RM = '/risico-monitor/register';
export const ROUTE_ACCOUNT_GRANT_RM = '/risico-monitor/grant';
export const ROUTE_FORM_QUIZ = '/form/quiz';
export const ROUTE_RESULT = '/resultaat/';
export const ROUTE_NEWSLETTER_SUBSCRIBE = '/newsletter';
export const ROUTE_SUCCESS_REGISTER = '/success/register';
// TEMP url paths.
export const ROUTE_NEWSLETTER_SETTINGS = '/account/email';
export const ROUTE_ADDRESS_SETTINGS = '/addresses';
